import { render, staticRenderFns } from "./SetupTransfer.vue?vue&type=template&id=35ecd29c&scoped=true&"
import script from "./SetupTransfer.vue?vue&type=script&lang=js&"
export * from "./SetupTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ecd29c",
  null
  
)

export default component.exports